import * as React from "react";
const ToggleButton = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <rect width={32} height={32} fill="#fff" fillOpacity={0.08} rx={16} />
    <mask
      id="aToggleButton"
      width={24}
      height={24}
      x={4}
      y={4}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M4 4h24v24H4z" />
    </mask>
    <g mask="url(#aToggleButton)">
      <path
        fill="#F1F5F9"
        d="M10 24c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 8 22c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 10 20c.55 0 1.02.196 1.412.587.392.392.588.863.588 1.413s-.196 1.02-.588 1.413A1.926 1.926 0 0 1 10 24Zm6 0c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 14 22c0-.55.196-1.02.588-1.413A1.926 1.926 0 0 1 16 20c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413s-.196 1.02-.587 1.413A1.926 1.926 0 0 1 16 24Zm6 0c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 20 22c0-.55.196-1.02.587-1.413A1.926 1.926 0 0 1 22 20c.55 0 1.02.196 1.413.587.391.392.587.863.587 1.413s-.196 1.02-.587 1.413A1.926 1.926 0 0 1 22 24Zm-12-6c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 8 16c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 10 14c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412 0 .55-.196 1.02-.588 1.413A1.926 1.926 0 0 1 10 18Zm6 0c-.55 0-1.02-.196-1.412-.587A1.926 1.926 0 0 1 14 16c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 16 14c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412 0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 16 18Zm6 0c-.55 0-1.02-.196-1.413-.587A1.926 1.926 0 0 1 20 16c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 22 14c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412 0 .55-.196 1.02-.587 1.413A1.926 1.926 0 0 1 22 18Zm-12-6c-.55 0-1.02-.196-1.412-.588A1.926 1.926 0 0 1 8 10c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 10 8c.55 0 1.02.196 1.412.588.392.391.588.862.588 1.412 0 .55-.196 1.02-.588 1.412A1.926 1.926 0 0 1 10 12Zm6 0c-.55 0-1.02-.196-1.412-.588A1.926 1.926 0 0 1 14 10c0-.55.196-1.02.588-1.412A1.926 1.926 0 0 1 16 8c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412 0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0 1 16 12Zm6 0c-.55 0-1.02-.196-1.413-.588A1.926 1.926 0 0 1 20 10c0-.55.196-1.02.587-1.412A1.926 1.926 0 0 1 22 8c.55 0 1.02.196 1.413.588.391.391.587.862.587 1.412 0 .55-.196 1.02-.587 1.412A1.926 1.926 0 0 1 22 12Z"
      />
    </g>
  </svg>
);
export default ToggleButton;
